export const Header = () => `
        <header id="game-header" class="main-site-navbar">
            <!-- Left: Empty or spacer now that logo is removed -->
            <div class="header-left">
            </div>

            <!-- Center Horizontal Navigation Menu Bar (Smooth Scroll Anchors) -->
            <nav class="top-horizontal-menu" style="margin-left: 0 !important;">
                <a href="#home-section" class="top-nav-link active" onclick="event.preventDefault(); document.getElementById('home-section')?.scrollIntoView({ behavior: 'smooth' }); document.querySelectorAll('.top-nav-link').forEach(el => el.classList.remove('active')); this.classList.add('active');">ANA SAYFA</a>
                <a href="#about-section" class="top-nav-link" onclick="event.preventDefault(); document.getElementById('about-section')?.scrollIntoView({ behavior: 'smooth' }); document.querySelectorAll('.top-nav-link').forEach(el => el.classList.remove('active')); this.classList.add('active');">HAKKIMIZDA</a>
                <a href="#contact-section" class="top-nav-link" onclick="event.preventDefault(); document.getElementById('contact-section')?.scrollIntoView({ behavior: 'smooth' }); document.querySelectorAll('.top-nav-link').forEach(el => el.classList.remove('active')); this.classList.add('active');">İLETİŞİM</a>
            </nav>

            <!-- Right Group: Settings & Music Buttons -->
            <div class="header-right">
                <button id="header-music-btn" class="header-btn" aria-label="Müzik ve Ses Ayarları">
                    <span class="icon" aria-hidden="true">🔊</span>
                </button>
                <button id="header-settings-btn" class="header-btn settings-btn" aria-label="Ayarları Aç">
                    <span class="icon" aria-hidden="true">⚙️</span>
                </button>
            </div>
        </header>
`;
